import Styles from './inputs.module.scss';
import { Controller } from 'react-hook-form'
import Select from 'react-select'
import { parseObjByString } from '../../utils';

const SelectInput = ({ name, isSearchable, isMulti=false, placeholder="Select...", label, hideLabel=false,isClearable=false, options,onChangeSelect = null, disabled, register, errors, styles,required, type, validationSchema, control, marginBottom }) => {
    const fieldError = errors?.[name] ?? parseObjByString(errors, name)[0];

    return (
        <div className={`${Styles.selectInput} w-full${marginBottom === 0 ? ` ${Styles.selectInputCompact}` : ""}`} style={marginBottom !== undefined && marginBottom !== 0 ? { marginBottom } : undefined}>
            {!hideLabel && <label htmlFor={name} className='block text-left text-primary-grey text-[13px] font-semibold pb-1'>
                {label}
                {validationSchema && validationSchema?.required ? " *": ""}
            </label>}
            {/* mb-8 */}
            <div className="relative text-left">
                <Controller
                    control={control}
                    id={name}
                    name={name}
                    rules={validationSchema}
                    render={({ field: { value, onChange } }) => (
                        <Select
                            isSearchable={isSearchable}
                            value={isMulti
                                ? options.filter(option => (Array.isArray(value) ? value : []).includes(option.value))
                                : (options.find(option => option.value === value || option.value === Number(value)) ?? null)}
                            onChange={(v) => {
                                onChange(isMulti ? (v ? v.map(o => o.value) : []) : (v ? v.value : null))
                                onChangeSelect !== null && onChangeSelect(v);
                            }}
                            isClearable={isClearable}
                            placeholder={placeholder}
                            isMulti={isMulti}
                            className={`inputField w-full flex-1 ${Styles.reactSelectContainer}`}
                            options={options}
                            isDisabled={disabled}
                            styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  ...styles
                                }),
                            }}
                        />
                    )}
                />  

                {fieldError?.type === "required" && (
                    <span className="left error">{fieldError.message}</span>
                )}
                {fieldError?.type === "minLength" && (
                    <span className="error">{fieldError.message}</span>
                )}
                {(fieldError?.type === "validate" || fieldError?.type === "manual") && (
                    <span className="error">{fieldError.message}</span>
                )}
            </div>
        </div>)
};
export { SelectInput };